<label class="checkbox-container" >
    <ng-content></ng-content>
    <input type="checkbox" [disabled]="disabled" [checked]="checked" (click)="onCheckboxChange()">
    <span class="checkmark"></span>
</label>